(function () {
    'use strict';

    angular
        .module('app.user')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'profile',
                config: {
                    url: '/profile',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'Profile'
                    },
                    data: {
                        permissions: {
                            only: ['AUTHORIZED'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'profile.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/user/profile/user.profile.html',
                    controller: 'ProfileManagementController',
                    controllerAs: 'vm',
                    title: 'Profile Management',
                    settings: {
                        isVisible: true,
                        nav: 2,
                        content: '<i class="fa fa-user"></i> Profile Management'
                    }
                }
            }
        ];
    }
})();
